import { SET_LIFECYCLE_PHASE } from "./types";
import { AppLifecyclePhase } from "../models/refsixState";

export const setLifecyclePhase = (
    phase: AppLifecyclePhase,
    error?: string
) => ({
    type: SET_LIFECYCLE_PHASE,
    phase,
    error,
});
